import "./index.scss";

import * as React from "react";
import { createRoot } from 'react-dom/client';

import {App} from "./components/app";
import {AppConfiguration} from "./core/config/app-configuration";
import {MapViewerConfiguration} from "./config/map-viewer-configuration";

import { JsonSerializer } from "typescript-json-serializer";

import esriRequest from "@arcgis/core/request";
import {BrowserRouter, Outlet, Route, Routes, useNavigate, useLocation, useParams, useSearchParams}
    from "react-router-dom";

import {AppState} from "./components/app/app-mobx";
import {Notfound} from "./core/components/not-found/not-found";

import RequestResponse = __esri.RequestResponse;
import MatomoTracker from "@datapunt/matomo-tracker-js";

const loadConfig = (url: string, file: string): Promise<RequestResponse> => {
    const path = url + "/" + file;
    return esriRequest(path, {
        responseType: "json"
    });
};

// TODO: auf APP_ROOT umstellen bzw. auf unterschiedliche URL pro Zielumgebung (Target)
// TODO: In JSON die Pfade auf Icons ersetzen je nach Target
const loadConfigs = async (url: string) =>
    // use typescript dynamic import to load the config json files
    await Promise.all([
        loadConfig(url, "core.json"),
        loadConfig(url, "mapviewer.json")
    ]);

if (!new class { x: any }().hasOwnProperty("x")) { throw new Error("Transpiler is not configured correctly"); }

// Map to the country class
try {

    // __CONFIG_ROOT__ is replaced by Webpack build process
    // see config/environments
    // noinspection UnnecessaryLocalVariableJS
    const configRoot = __CONFIG_ROOT__;
    loadConfigs(configRoot).then(([appJson, mapviewerJson]) => {
        const defaultSerializer = new JsonSerializer();
        const appConfig = defaultSerializer.deserializeObject<AppConfiguration>(appJson.data, AppConfiguration);

        // deserialize as specific configuration type, but pass it to the App as generic base class type
        const mapViewerConfig =
            defaultSerializer.deserializeObject(mapviewerJson.data, MapViewerConfiguration);
        if (appConfig && mapViewerConfig) {
            const tracker =
                (mapViewerConfig.tracker !== undefined) ? new MatomoTracker(mapViewerConfig.tracker) : undefined;
            const appStore = new AppState(mapViewerConfig, tracker);
            // https://gist.github.com/mjackson/d54b40a094277b7afdd6b81f51a0393f#gistcomment-3966800
            const RouteElement = ({component: RouteComponent, ...passProps}: any) => {
                const location = useLocation();
                const navigate = useNavigate();
                const params = useParams();
                const [searchParams, setSearchParams] = useSearchParams();
                return (<RouteComponent {...passProps} location={location} navigate={navigate}
                    params={params} searchParams={searchParams}
                    setSearchParams={setSearchParams} />
                );
            };

            const container = document.getElementById("app-root");
            const root = createRoot(container!);
            root.render(
                (<BrowserRouter basename={appConfig.basename}>
                    <Routes>
                        <Route
                            path="/"
                            element={
                                <RouteElement
                                    component={App}
                                    config={appConfig}
                                    moduleConfig={mapViewerConfig}
                                    appStore={appStore}
                                />
                            }
                        >
                            <Route path=":subtopic" element={<Outlet/>} />
                            <Route path=":subtopic/:objectId" element={<Outlet/>} />
                            <Route path=":subtopic/:objectId/:addId" element={<Outlet/>} />
                        </Route>
                        <Route path="*" element={<Notfound/>} />
                    </Routes>
                </BrowserRouter>)
            );
        }
    }).catch((error) => {
        // eslint-disable-next-line no-console
        console.error(error);
    });
} catch (e) {
    // eslint-disable-next-line no-console
    console.error(e);
}
